import script from "./EventV2Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventV2Index.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__